import { NgModule } from '@angular/core';
import { PluginAccountDropdownFormExtensionComponent } from './components/plugin-account-dropdown/plugin-account-dropdown.component';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonsModule } from '@anecdotes/design-system/buttons';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { PluginsConnectionModule } from '@anecdotes/plugins-connection';
import { DynamicFormModule } from '@anecdotes/dynamic-form';
import { PluginAccountDropdownControlComponent } from './components/plugin-account-dropdown-control/plugin-account-dropdown-control.component';
import { NavigateToPluginComponent } from './components/navigate-to-plugin/navigate-to-plugin.component';

@NgModule({
  declarations: [
    PluginAccountDropdownControlComponent,
    PluginAccountDropdownFormExtensionComponent,
    NavigateToPluginComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    PluginsConnectionModule.forRoot(),
    ButtonsModule,
    TranslateModule.forChild(),
    NgbTooltipModule,
    DynamicFormModule,
  ],
  exports: [
    PluginAccountDropdownControlComponent,
    PluginAccountDropdownFormExtensionComponent,
    NavigateToPluginComponent,
  ],
})
export class PluginsUtilsModule {}
